/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminMarketplace
 */
export interface AdminMarketplace {
    /**
     * 
     * @type {string}
     * @memberof AdminMarketplace
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketplace
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AdminMarketplace
     */
    link: string;
    /**
     * LinkBrokenAt is since when the link no longer leads to a live listing
     * (found by the daily check, eBay only); null while it works or was not checked.
     * @type {string}
     * @memberof AdminMarketplace
     */
    linkBrokenAt?: string;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminMarketplace
     */
    name: AdminMarketplaceType;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketplace
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof AdminMarketplace
     */
    updatedAt: string;
}



export function AdminMarketplaceFromJSON(json: any): AdminMarketplace {
    return AdminMarketplaceFromJSONTyped(json, false);
}

export function AdminMarketplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'link': json['link'],
        'linkBrokenAt': !exists(json, 'linkBrokenAt') ? undefined : json['linkBrokenAt'],
        'name': AdminMarketplaceTypeFromJSON(json['name']),
        'price': json['price'],
        'updatedAt': json['updatedAt'],
    };
}

export function AdminMarketplaceToJSON(value?: AdminMarketplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'link': value.link,
        'linkBrokenAt': value.linkBrokenAt,
        'name': AdminMarketplaceTypeToJSON(value.name),
        'price': value.price,
        'updatedAt': value.updatedAt,
    };
}

